<template>
  <v-app>
    <Nav/>
    <v-main>
      <router-view/>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Nav from './components/Nav.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  
  components: {
    Nav,
    Footer,
  },
  data: () => ({
    //
  }),
};
</script>
<style>
  @import url("https://use.typekit.net/svy2qnr.css");

  html, body {
    height: 100%;
  }

  body {
    font-family: neo-sans, sans-serif !important;
    font-style: normal;
    font-weight: 300;
  }
  #app {
    font-family: neo-sans, sans-serif !important;
  }
</style>